import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Loader from "../child/Loder";
import DengerAlert from "../child/Alert/DengerAlert";
import { handleUnauthorized } from "../../utils/apiHelper";
import moment from "moment";
import { fetchHelpSupportById } from "../services/helpSupportService";
import { formatAction } from "../../utils/formatAction";

const HelpSupportViewPage = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const [support, setSupport] = useState(null);
    const [loading, setLoading] = useState(true);
    const [errorMessage, setErrorMessage] = useState("");
    const [activeTab, setActiveTab] = useState("support-info");

    useEffect(() => {
        fetchSupport();
        // eslint-disable-next-line
    }, [id]);

    const fetchSupport = async () => {
        setLoading(true);
        try {
            const { data } = await fetchHelpSupportById(id);
            setSupport(data?.data);
        } catch (err) {
            if (err.response?.status === 401) {
                handleUnauthorized(navigate);
                return;
            }
            setErrorMessage(err.response?.data?.message || err.message);
            setTimeout(() => setErrorMessage(""), 3000);
        } finally {
            setLoading(false);
        }
    };

    if (loading) return <Loader />;

    return (
        <div className="row gy-4">
            <div className="col-md-12">
                <div className="card h-100">
                    <div className="card-body p-24">
                        {/* Error Alert */}
                        {errorMessage && (
                            <DengerAlert
                                message={errorMessage}
                                onClose={() => setErrorMessage("")}
                            />
                        )}

                        {/* Tabs */}
                        <ul
                            className="nav border-gradient-tab nav-pills mb-20 d-inline-flex"
                            role="tablist"
                        >
                            <li className="nav-item" role="presentation">
                                <button
                                    className={`nav-link d-flex align-items-center px-24 ${activeTab === "support-info" ? "active" : ""
                                        }`}
                                    onClick={() => setActiveTab("support-info")}
                                    type="button"
                                    role="tab"
                                >
                                    Support Info
                                </button>
                            </li>
                        </ul>

                        {/* Tab Content */}
                        <div className="tab-content">
                            <div
                                className={`tab-pane fade ${activeTab === "support-info" ? "show active" : ""
                                    }`}
                                role="tabpanel"
                            >
                                <div className="row">
                                    {/* Full Name */}
                                    <div className="col-md-4 mb-3">
                                        <label className="form-label fw-bold">Full Name:</label>
                                        <div>{support?.fullName || "N/A"}</div>
                                    </div>

                                    {/* Email */}
                                    <div className="col-md-4 mb-3">
                                        <label className="form-label fw-bold">Email:</label>
                                        <div>{support?.email || "N/A"}</div>
                                    </div>

                                    {/* Status */}
                                    {/* <div className="col-md-4 mb-3">
                                        <label className="form-label fw-bold">Status:</label>
                                        <div className="text-capitalize">
                                            {formatAction(support?.status || "N/A")}
                                        </div>
                                    </div> */}
                                    <div className="col-md-4 mb-3">
                                        <label className="form-label fw-bold">Contact Number:</label>
                                        <div>
                                            {support?.contactnumber
                                                ? support?.contactnumber
                                                : "N/A"}
                                        </div>
                                    </div>
                                    <div className="col-md-4 mb-3">
                                        <label className="form-label fw-bold">Conuntry Code:</label>
                                        <div>
                                            {support?.conuntrycode
                                                ? support?.conuntrycode
                                                : "N/A"}
                                        </div>
                                    </div>

                                    <div className="col-md-4 mb-3">
                                        <label className="form-label fw-bold">App Version:</label>
                                        <div>
                                            {support?.appVersion
                                                ? support?.appVersion
                                                : "N/A"}
                                        </div>
                                    </div>
                                    <div className="col-md-4 mb-3">
                                        <label className="form-label fw-bold">PlatForm:</label>
                                        <div>
                                            {support?.platform
                                                ? support?.platform
                                                : "N/A"}
                                        </div>
                                    </div>


                                    {/* Created At */}
                                    <div className="col-md-4 mb-3">
                                        <label className="form-label fw-bold">Created At:</label>
                                        <div>
                                            {support?.createdAt
                                                ? moment(support.createdAt).format(
                                                    "DD-MM-YYYY, hh:mm A"
                                                )
                                                : "N/A"}
                                        </div>
                                    </div>

                                    {/* Updated At */}
                                    <div className="col-md-4 mb-3">
                                        <label className="form-label fw-bold">Updated At:</label>
                                        <div>
                                            {support?.updatedAt
                                                ? moment(support.updatedAt).format(
                                                    "DD-MM-YYYY, hh:mm A"
                                                )
                                                : "N/A"}
                                        </div>
                                    </div>
                                    {/* Message */}
                                    <div className="col-md-12 mb-3">
                                        <label className="form-label fw-bold">Message:</label>
                                        <div className="border p-3 rounded bg-light">
                                            {support?.message || "N/A"}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* End Tab */}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HelpSupportViewPage;
